export const cilGem = ["24 24","<path d='M19.151 2.25h-14.303l-4.099 6.148v1.162l8.598 12.94h5.304l8.598-12.94v-1.162zM18.349 3.75l2.972 4.458h-5.021l-1.403-4.458zM10.675 3.75h2.65l1.403 4.458h-5.455zM5.651 3.75h3.451l-1.403 4.458h-5.021zM10.152 21l-7.503-11.292h5.006l2.648 11.292zM11.844 21l-2.648-11.292h5.608l-2.648 11.292zM13.848 21h-0.152l2.648-11.292h5.006z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-gem.js
// module id = null
// module chunks = 